import { CALENDAR_YEAR } from '../config';

export const YEAR = CALENDAR_YEAR;

/** Date the site first went live — used as datePublished for evergreen pages */
export const SITE_LAUNCH_DATE = '2025-09-01';

export const TYPE_DISPLAY: Record<string, string> = {
  public_holiday: 'Public Holidays',
  national_day: 'National Days',
  observance: 'Observances',
  cultural_festival: 'Cultural Festivals',
  local_event: 'Local Events',
};

export const RELIGION_DISPLAY_NAMES: Record<string, string> = {
  islamic: 'Islamic',
  hindu: 'Hindu',
  lunar: 'Lunar',
  christian: 'Christian',
  buddhist: 'Buddhist',
};
